<ycn-modal-base
    [modalBaseClass]="'modal-fix-scroll'"
    [extraModalClasses]="'modal-no-border user-select-none'"
    [open]="modalOpen"
    (closeModalHandler)="closeModal()">
    <ycn-simple-modal-header
        [header]="saveItemsLabel"
        [showUnsavedStatus]="false"
        (closeModalHandler)="closeModal()">
    </ycn-simple-modal-header>
    <div class="modal-body">
        <ycn-loading-symbol *ngIf="loading" [loaderMessage]="'Loading...'"></ycn-loading-symbol>
        <ng-container *ngIf="!loading">
            <ycn-open-item-tabs
                    [ownItems]="ownItems"
                    [sharedItems]="sharedItems"
                    [sharedWithMeEnabled]="sharedWithMeEnabled"
                    [selectOnly]="selectOnly"
                    [savedItemType]="savedItemType"
                    (doActionOnItemHandler)="doActionOnItem($event)"
            ></ycn-open-item-tabs>
        </ng-container>
    </div>
    <div class="modal-footer user-select-none" *ngIf="errorMessage">
        <div class="popupFooter">
            <span class="text-red" [textContent]="errorMessage"></span>
        </div>
    </div>
</ycn-modal-base>
<ycn-feature-needed></ycn-feature-needed>
